

import { useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRowView } from 'components/shared';
import InfoAlertView from "components/shared/views/InfoAlertView";
import React from 'react';
import { SVGAsset } from "res";
import TASPositivePayExceptionChecksDesktopContentView from "../TASPositivePayExceptionChecksDesktopContentView";
import "./styles.css";

/**
 * @function TASPositivePayExceptionChecksDesktopView
 * @return {React.Component}
 * @exported true
 * @description The "TAS Positive Pay Exception Checks" desktop view.
 */
export default function TASPositivePayExceptionChecksDesktopView() {
    const { data, ui, onChange, onClear, onSearch } = useStateManager();
    const exceptionCheckForms = data.exceptionCheckForms;
    const hasSearchResults = data.exceptionCheckForms.length > 0;
    const search = data.search;
    const accountItems = search.accounts.reduce((acc, item) => {
        acc.push(
            <CustomSelectItem key={ item.id } value={ item.id }>{ `${ item.name } ${ item.number }` }</CustomSelectItem>
        )
        return acc;
    }, []);

    const editExceptionChecksHaveReturnReasonError = search.editExceptionChecksHaveReturnReasonError;
    const numberOfChangesSaved = ui.search.didSaveChanges.numberOfChangesSaved;
    const updatedMessage = numberOfChangesSaved > 1
    ? `You have successfully updated ${ numberOfChangesSaved } exceptions.`
    : `You have successfully updated ${ numberOfChangesSaved } exception.`;
    
    return (
        <div className="show-on-desktop tas-positive-pay-exceptions-checks-desktop-view-container">
            { !ui.search.didSearch.isActive && 
            <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                <div className="set-width curfew-alert">
                    <InfoAlertView text="Please use search to find checks." icon={ <SVGAsset id="InfoIcon" /> } />
                </div>
            </div>
            }
            { ui.search.didSaveChanges.isActive && 
            <div className="flex-container flex-horizontal past-review-cutoff-time-container">
                <div className="set-width success-alert">
                    <InfoAlertView text={ updatedMessage } className="align-center checkmark-style"
                    dataPoint="TAS_Positive_Pay_Exception_Checks_Desktop_Successfully_Saved_Alert_View"
                    icon={ <SVGAsset id="check_circle" className="checkmark-icon material-symbols-outlined" /> } />
                </div>
            </div>
            }
            <FormContainer className="search-form-container">
                <div className="flex-container flex-horizontal">
                    <div className="set-width item">
                        <FormRowView text="Account">
                            <CustomSelect active={ ui.search.account.isActive } value={ search.account.id } dataPoint="TAS_Positive_Pay_Exception_Checks_Desktop_Account_Select"
                             onChange={ onSearch("account") }>
                                { accountItems }
                            </CustomSelect>
                        </FormRowView>
                    </div>
                    <div className="flex-width review-cutoff-time-container">
                      <InfoAlertView className="align-center" dataPoint="TAS_Positive_Pay_Exception_Checks_Desktop_Time_Info_Alert_View"
                       text="Review cutoff time: 09:30 AM"
                       icon={ <SVGAsset id="schedule" className="material-symbols-outlined" /> }/>
                    </div>
                </div>
                <div className="flex-container flex-horizontal error-alert-container">
                    { editExceptionChecksHaveReturnReasonError
                    && <>
                    <InfoAlertView className="alert set-width" text="Please provide return reason(s)." icon={ <SVGAsset id="AlertTriangleIcon" className="" /> } />
                    <div className="flex-width"></div>
                    </> }
                </div>
            </FormContainer>
            
            { ui.search.didSearch.isActive && hasSearchResults && 
            <TASPositivePayExceptionChecksDesktopContentView/>
            }
            
            { !hasSearchResults && <div className="flex-width text-center">No exception is available.</div> }
            
        </div>
    )
}